<template>
    <el-dialog
            title="调价"
            :visible.sync="visible"
            width="506px"
            :append-to-body="true"
            @close="cancelHandle"
    >
        <el-form :model="priceForm" :rules="priceRules" ref="priceForm" class="priceForm" :label-position="'right'"  label-width="110px">
            <el-form-item label="调价方式:" prop="adjustmentType">
                <el-select style="width: 200px" v-model="priceForm.adjustmentType" placeholder="调价方式" @change="selectChange">
                    <el-option
                            v-for="item in adjustmentTypeArr"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                    v-if="priceForm.adjustmentType === 1"
                    label="增幅比例(%):"
                    prop="percentage"
                    key="1"
                    :rules="[{ required: true, validator: validateNumber1, trigger: 'blur' }]"
            >
                <el-input @input="limitInput($event, 'percentage')"  style="width: 200px" v-model.number="priceForm.percentage" placeholder="请输入增幅比例"></el-input>
                <span class="amplification">(1-200)</span>
            </el-form-item>
            <el-form-item
                    v-if="priceForm.adjustmentType === 2"
                    label="降幅比例(%):"
                    prop="percentage"
                    key="2"
                    :rules="[{ required: true, validator: validateNumber2, trigger: 'blur' }]"
            >
                <el-input @input="limitInput($event, 'percentage')"    style="width: 200px" v-model.number="priceForm.percentage" placeholder="请输入降幅比例"></el-input>
                <span class="amplification">(1-80)</span>
            </el-form-item>
            <el-form-item
                    v-if="priceForm.adjustmentType === 3"
                    label="增幅数值:"
                    prop="adjustmentPrice"
                    key="3"
                    :rules="[{ required: true, validator: validateNumber35, trigger: 'blur' }]"
            >
                <el-input @input="limitInput($event, 'adjustmentPrice')"   style="width: 200px" v-model="priceForm.adjustmentPrice" placeholder></el-input>
                <span class="amplification">元</span>
            </el-form-item>
            <el-form-item
                    v-if="priceForm.adjustmentType === 4"
                    label="降幅数值:"
                    prop="adjustmentPrice"
                    key="4"
                    :rules="[{ required: true, validator: validateNumber4, trigger: 'blur' }]"
            >
                <el-input  @input="limitInput($event, 'adjustmentPrice')"  style="width: 200px" v-model="priceForm.adjustmentPrice" placeholder></el-input>
                <span class="amplification">元</span>
            </el-form-item>
            <el-form-item
                    v-if="priceForm.adjustmentType === 5"
                    label="固定数值:"
                    prop="adjustmentPrice"
                    key="5"
                    :rules="[{ required: true, validator: validateNumber35, trigger: 'blur' }]"
            >
                <el-input  @input="limitInput($event, 'adjustmentPrice')"  style="width: 200px" v-model="priceForm.adjustmentPrice" placeholder></el-input>
                <span class="amplification">元</span>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelHandle">取 消</el-button>
            <el-button type="primary" @click="handleAdjustPrice">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>

    const numberReg = /^\d+$|^\d+[.]?\d+$/
    const numberReg2 = /^([0-9][0-9]*)+(\.[0-9]{1,2})?$/
    const validateNumber1 = (rule, value, callback) => {
        if (!numberReg.test(value) || value < 1 || value > 200) {
            callback(new Error('输入格式必须为1-200数字'))
        } else {
            callback()
        }
    }
    const validateNumber2 = (rule, value, callback) => {
        if (!numberReg.test(value) || value < 1 || value > 80) {
            callback(new Error('输入格式必须为1-80数字'))
        } else {
            callback()
        }
    }
    const validateNumber35 = (rule, value, callback) => {
        if (!numberReg2.test(value) || value < 0 || value > 1000000000) {
            callback(new Error('请输入0-10亿的正数，小数点后最多2位'))
        } else {
            callback()
        }
    }

    const validateNumber4 = (rule, value, callback) => {
        if (!numberReg2.test(value) || value < 0) {
            callback(new Error('输入格式正数数字，小数点后最多两位'))
        } else {
            callback()
        }
    }
    const adjustmentTypeArr = [
        {
            key: 1,
            value: '按比例增幅'
        },
        {
            key: 2,
            value: '按比例降幅'
        },
        {
            key: 3,
            value: '按数值增幅'
        },
        {
            key: 4,
            value: '按数值降幅'
        },
        {
            key: 5,
            value: '固定价'
        }
    ]
    export default {
        name: "multiAdjustPriceDialog",
        components: {
        },
        props: {
            visible:{
                type:Boolean,
                required: true
            },
            price: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                dialogTitle:'调价',
                priceForm: {
                    adjustmentType:2,
                    percentage: '',
                    adjustmentPrice: ''
                },
                priceRules: {
                    adjustmentType: [{ required: true, message: '请选择调价方式', trigger: 'change' }]
                    // percentage: [{ required: true, message: "请填写增/降幅比例", trigger: "change" }],
                },
                adjustmentTypeArr,
                validateNumber1,
                validateNumber2,
                validateNumber4,
                validateNumber35

            }
        },
        computed: {},
        created() {
        },
        methods: {
            limitInput(value, name) {
                this.priceForm[name] = ('' + value) // 第一步：转成字符串
                .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
                .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
                .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
                .match(/^\d*(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，	而且小数点后面只能有0到2位小数
            },
  
            selectChange() {
                this.priceForm.percentage = ''
                this.priceForm.adjustmentPrice = ''
            },
            cancelHandle() {
                this.$refs.priceForm.resetFields()
                this.$emit('close')
            },
            handleAdjustPrice() {
                this.$refs.priceForm.validate(valid => {
                    if (valid) {
                        const params = { ...this.priceForm }
                        if (params.adjustmentPrice) {
                            delete params.percentage
                        }
                        if (params.percentage) {
                            delete params.adjustmentPrice
                        }
                        if (this.priceForm.adjustmentType === 4) {
                            if (this.priceForm.adjustmentPrice - this.price > 0) {
                                this.$message({
                                    message: '降幅数值不可大于市场公开价',
                                    type: 'warning'
                                })
                                return
                            }
                        }


                        this.$nextTick(() => {
                            this.$emit('update:visible', false)
                            // this.$refs.priceForm.resetFields()
                        })
                        this.$emit('handleAdjustPrice', this.priceForm)
                    } else {
                        return false
                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>
